<label
  *ngIf="label"
  [ngClass]="labelClasses"
  [for]="inputId">
  {{label | translate}}
  <pcs-tooltip *ngIf="labelDetails" icon="info_outline">
    {{labelDetails}}
  </pcs-tooltip>
</label>
<div class="select-wrapper" [ngClass]="inputWrapperClasses">
  <pcs-loader *ngIf="loading"></pcs-loader>
  <input
    #inputRef
    autocomplete="off"
    type="text"
    [ngClass]="inputClasses"
    [id]="inputId"
    [name]="name"
    [value]="searchTerm"
    [disabled]="disabled"
    [readonly]="readonly"
    [tabindex]="tabindex"
    placeholder="{{placeholder | translate}}"
    (input)="selectChange.next($event)"
    (keypress)="selectKeyPress.next(null)"
    (keydown)="selectKeyDown.next($event)"
    (blur)="selectBlur.next($event)"
    (focus)="selectFocus.next(null)" />

  <pcs-tooltip *ngIf="showTooltip()" tabIndex="-1">
    {{placeholder | translate}}
  </pcs-tooltip>

  <ng-content></ng-content>
</div>
